module.exports = __webpack_public_path__ + "static/corporate-banner-1-min.0ec848fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialize-theme/img/corporate/corporate-banner-1-min.jpg
// module id = 805
// module chunks = 168707334958949